import { StepDot as Dot } from './Dot';
import { StepNumber as Number } from './Number';
import { Step } from './Step';
import { Steps as StepsComponent } from './Steps';
export var Steps = Object.assign(StepsComponent, {
  Step: Step,
  Dot: Dot,
  Number: Number
});